const filterType = {
    Business: 'Business',
    Publisher: 'Publisher'
  };
  
export default filterType;


// WEBPACK FOOTER //
// ./src/constants/filter-type.js